import { getBookmarkOptions } from '@metto/http-clients/api';
import type { AnyRoute } from '@tanstack/react-router';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

export const createBookmarksRoutes = <TParent extends AnyRoute>(
  parent: TParent
) => {
  const editBookmarkRoute = createRoute({
    path: '/bookmarks/$id/edit',
    getParentRoute: () => parent,
    component: lazyRouteComponent(() => import('./pages/EditBookmarkPage')),
    loader: async ({ params, context }) => {
      await context.queryClient.ensureQueryData(
        getBookmarkOptions({ path: { id: params.id } })
      );
    }
  });

  return [editBookmarkRoute];
};
